import React, { useEffect, useState } from "react";
import "./Notifications.css";
import { Container, Row, Card, Col } from "react-bootstrap";
import Sidebar from "../../components/SidebarQA/Sidebar";
import { Link } from "react-router-dom";
import {
  GetNotifications,
  GetNotificationUnreadCount,
  MarkNotificationRead,
} from "../../apis/NotificationAPI";
import dateFormat from "dateformat";

export default function Notifications() {
  const [notificationList, setNotificationList] = useState([]);
  const [unreadCount, setUnreadCount] = useState(0);

  async function GetUserNotifications() {
    var result = await GetNotifications();
    var data = result.data;
    setNotificationList(data);
  }

  async function GetNotificationCount() {
    var result = await GetNotificationUnreadCount();
    setUnreadCount(result.data);
  }

  async function MarkNotification() {
    var result = await MarkNotificationRead();
    console.log(result);
  }

  useEffect(() => {
    GetUserNotifications();
    GetNotificationCount();
    MarkNotification();
  }, []);

  window.addEventListener("notification", () => {
    GetUserNotifications();
    GetNotificationCount();
    MarkNotification();
  });

  return (
    <>
      <Container fluid>
        <Row>
          <div className="admin-wrapper">
            <div className="left-section">
              <Sidebar />
            </div>
            <div className="right-section">
              <Container fluid>
                <h1>Notifications {unreadCount > 0 ? `(${3})` : ""}</h1>
                <Row>
                  <Col lg={12}>
                    <Card className="notifications-card">
                      {/* <div className="card-head">
                                        <div className="card-title h5">Notifications</div>
                                    </div> */}
                      <ul className="notifications-list">
                        {notificationList.map((item) =>
                          item.order_status_name === "Initial Review" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has sent Order number{" "}
                                <Link
                                  to={`/QA/OrderDetails?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>'s{" "}
                                initial report for review.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Prelim In Review" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                {item.order_user} has sent Order number{" "}
                                <Link
                                  to={`/QA/OrderDetails?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>'s{" "}
                                prelim report for review.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : item.order_status_name === "Reopened" ? (
                            <li
                              className={item.view_id === 0 ? "unread" : ""}
                              key={item.id}
                            >
                              <p>
                                Order number{" "}
                                <Link
                                  to={`/QA/OrderDetails?id=${item.order_id}`}
                                >
                                  {item.order_id}
                                </Link>{" "}
                                has been reopened for editing.
                              </p>
                              <span className="text-italic">
                                {dateFormat(
                                  new Date(item.created_date + "Z"),
                                  "mmmm dd, yyyy hh:mmtt"
                                )}
                              </span>
                            </li>
                          ) : (
                            ""
                          )
                        )}
                      </ul>
                      {/* <Card.Link href="#">View All</Card.Link> */}
                    </Card>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
        </Row>
      </Container>
    </>
  );
}
